/* eslint-disable id-length --
Copied from a not-yet-deployed https://js-libraries-doc.beslogic.com/
Eventually we can use it as a lib
*/

/**
 * Removes all accents from a string.
 *
 * If comparing strings, prefer `a.localeCompare(b, locales, {sensitivity: 'base'}) === 0`.
 * See: [String.prototype.localeCompare()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare)
 *
 * @param {string} text
 */
export const normalizeAccents = text =>
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
  text.normalize('NFD').replaceAll(/[\u{300}-\u{36F}]/gu, '');

/**
 * Split ligatures to their ASCII equivalent.
 *
 * If comparing strings, prefer `a.localeCompare(b, locales, {sensitivity: 'base'}) === 0`.
 * See: [String.prototype.localeCompare()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare)
 *
 * @param {string} text
 */
export const normalizeLigatures = text =>
  text
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
    .normalize('NFKD') // does ﬀ -> ff and more
    .replaceAll(/(ß)|(æ)|(Æ)/gu, (_, s, ae, AE) => {
      // uppercase ß is already SS
      if (s) return 's';
      if (ae) return 'ae';
      if (AE) return 'Æ';

      return '';
    });

/**
 * Checks if a string is found as part of another string
 * whilst ignoring accents, ligatures and/or casing.
 *
 * @param options Decide how you want to normalize the string.
 * If left empty, all normalization is applied by default.
 *
 * If comparing full strings, prefer `a.localeCompare(b, locales, {sensitivity: 'base'}) === 0`.\
 * See: [String.prototype.localeCompare()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare)
 *
 * @param {string} source
 * @param {string} searchValue
 * @param {{ ligatures?: boolean, accents?: boolean, casing?: boolean } | undefined} options
 */
export const includesNormalizedCaseInsensitive = (source, searchValue, options) => {
  const emptyOptions = !options || Object.keys(options).length === 0;
  if (emptyOptions || options.casing) {
    source = source.toLocaleUpperCase();
    searchValue = searchValue.toLocaleUpperCase();
  }
  if (emptyOptions || options.ligatures) {
    source = normalizeLigatures(source);
    searchValue = normalizeLigatures(searchValue);
  }
  if (emptyOptions || options.accents) {
    source = normalizeAccents(source);
    searchValue = normalizeAccents(searchValue);
  }

  return source.includes(searchValue);
};

/** @param {string} text */
export const sanitizeForRegex = text => text.replaceAll(/[$()*+\-./?[\\\]^{|}]/gu, String.raw`\$&`);
